module.exports = __webpack_public_path__ + "img/handraw_recette.2a513201.svg";